import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, TextButton, ConfirmationModal } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { Accounting } from '~/types/accounting';
import { BulletList, SectionHelper, PointIndication } from './components';
import styles from './ImportingInvoicesToQBOModal.module.scss';
//TODO - width and height shouldn't be fixed
export function ImportingInvoicesToQBOModal(props) {
    const { t: invoicesDashboardTexts } = useLocaleKeys('invoice.dashboard');
    const { t: commonTexts } = useLocaleKeys('common');
    const { onClose, downloadCsv, testId } = props;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'importing_invoices_to_q_b_o_confirm'
            },
            secondaryButton: {
                name: 'importing_invoices_to_q_b_o_cancel'
            }
        },
        testId: testId,
        title: invoicesDashboardTexts.importToQboTitle(),
        onCloseButtonClick: onClose,
        primaryButtonLabel: commonTexts.buttons.gotIt(),
        onPrimaryButtonClick: onClose,
        width: "590px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.content,
            children: [
                /*#__PURE__*/ _jsx(SectionHelper, {
                    className: styles.section,
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        variant: "paragraph2",
                        children: [
                            invoicesDashboardTexts.csvBeingDownloaded(),
                            ' ',
                            /*#__PURE__*/ _jsx(TextButton, {
                                bi: {
                                    name: 'learn_more_qbo_import'
                                },
                                skin: "secondary",
                                variant: "paragraph2",
                                onClick: downloadCsv,
                                children: invoicesDashboardTexts.clickHere()
                            }),
                            ' ',
                            invoicesDashboardTexts.clickHereIfNoDownload()
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.section,
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "h6",
                            className: styles.step,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    weight: "normal",
                                    as: "span",
                                    children: "Step 1:"
                                }),
                                ' ',
                                invoicesDashboardTexts.step1Title()
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.indicatedText,
                            children: [
                                /*#__PURE__*/ _jsx(PointIndication, {}),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.step1MatchDisplayNames()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.section,
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "h6",
                            className: styles.step,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    weight: "normal",
                                    as: "span",
                                    children: "Step 2:"
                                }),
                                ' ',
                                invoicesDashboardTexts.step2Title()
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(BulletList, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.step2InQboGoToSettings()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.step2SelectInvoices()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.step2UnderBrowse({
                                        accountingName: getAccountingDetails(Accounting.QBO).name
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.step2SelectAndUpload()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: invoicesDashboardTexts.continueWithQbo()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.section,
                    children: /*#__PURE__*/ _jsxs(Typography, {
                        skin: "secondary",
                        variant: "paragraph2",
                        children: [
                            invoicesDashboardTexts.needMoreHelp(),
                            ' ',
                            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                openInNewTab: true,
                                variant: "paragraph2",
                                href: "https://quickbooks.intuit.com/learn-support/en-us/help-article/import-export-data-files/import-multiple-invoices/L7E9Xrd8l_US_en_US",
                                bi: {
                                    name: 'qbo_import_invoices_help'
                                },
                                children: invoicesDashboardTexts.clickHereLink()
                            })
                        ]
                    })
                })
            ]
        })
    });
}
